var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }